import { FC, ReactNode, useMemo } from 'react'
import { parseMarkdown } from 'helpers/formatHelpers'
import { AccountTooltipLink } from 'components/features/pfm/LinkedAccountTooltip/AccountTooltipLink'

type AccountStatusExtraMessageProps = {
  message: string
}
export const AccountStatusExtraMessage: FC<AccountStatusExtraMessageProps> = (props) => {
  const { message } = props

  const children = useMemo(() => {
    return parseMarkdown(message)
      .reduce<ReactNode[]>((result, markdownElement) => {

        if (markdownElement.type === 'text') {
          return [...result, markdownElement.text]
        }

        if (markdownElement.type === 'link') {
          return [
            ...result,
            (
              <AccountTooltipLink key={ markdownElement.label } { ...markdownElement } />
            ),
          ]
        }

        return result
      }, [])
  }, [message])

  return (
    <>
      { children }
    </>
  )
}
